import { bpaasBaseApi } from 'yxt-biz-pc/packages/api';

// 获取项目详情
export const getProjectInfo = data => {
  return bpaasBaseApi.post(
    'apimaker-engine-func/faas/mengniu/empower/plans/detail',
    data
  );
};

// 获取项目变更详情
export const getProjectChangelogInfo = data => {
  return bpaasBaseApi.post(
    'apimaker-engine-func/faas/mengniu/empower/plans/changelog/detail',
    data
  );
};
